import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import MobileBottomNav from "./components/MobileBottomNav";
import CartDrawer from "./components/CartDrawer";
import LoadingScreen from "./components/LoadingScreen";

import Home from "./pages/Home";
import Menu from "./pages/Menu";
import About from "./pages/About";
import Checkout from "./pages/Checkout";
import OrderConfirmation from "./pages/OrderConfirmation";
import OrderTracking from "./pages/OrderTracking";
import Reviews from "./pages/Reviews";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

// Wrap the public storefront with the navbar/footer chrome.
// Admin pages render standalone (no Navbar/Footer/CartDrawer/etc.)
function StorefrontLayout({ children }) {
  return (
    <>
      <LoadingScreen />
      <Navbar />
      <main className="pb-16 lg:pb-0">{children}</main>
      <Footer />
      <MobileBottomNav />
      <CartDrawer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              {/* Admin (no storefront chrome) */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />

              {/* Storefront */}
              <Route path="/" element={<StorefrontLayout><Home /></StorefrontLayout>} />
              <Route path="/menu" element={<StorefrontLayout><Menu /></StorefrontLayout>} />
              <Route path="/about" element={<StorefrontLayout><About /></StorefrontLayout>} />
              <Route path="/checkout" element={<StorefrontLayout><Checkout /></StorefrontLayout>} />
              <Route path="/confirmation/:orderNumber" element={<StorefrontLayout><OrderConfirmation /></StorefrontLayout>} />
              <Route path="/track" element={<StorefrontLayout><OrderTracking /></StorefrontLayout>} />
              <Route path="/reviews" element={<StorefrontLayout><Reviews /></StorefrontLayout>} />
              <Route path="/contact" element={<StorefrontLayout><Contact /></StorefrontLayout>} />
            </Routes>
            <Toaster
              position="top-center"
              toastOptions={{
                style: {
                  background: "#05071A",
                  color: "#F6F2E8",
                  border: "1px solid rgba(200,154,54,0.4)",
                  fontFamily: "Outfit, sans-serif",
                },
              }}
            />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
